import React from "react";
import {
    NewsFeedDto,
    loadNewsFeedItems,
    getNewsFeed,
    getNewsFeedItem,
    newsFeedLoading,
} from "../../ducks/newsfeed";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import { connect } from "react-redux";
import {
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    Avatar,
    Grid,
} from "material-ui";
import {
    SetHeader,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
    SetBottomBarTab,
} from "../../ducks/common";
import AccountCircleIcon from "material-ui-icons/AccountCircle";
import { RouteProps, RouterProps, RouteComponentProps } from "react-router";
import { NewsFeedTab } from "components/BottomBar/BottomBar";

interface INewsFeedItemPageProps
    extends RouteComponentProps<{ itemId: number }> {}

interface INewsFeedItemPageReduxProps {
    item?: NewsFeedDto;
    loading: boolean;
}

interface INewsFeedItemPageDispatchProps {
    loadNewsFeed: () => Promise<void>;
    setHeader: (value: string) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    setBottomBarTab: (tab?: number) => void;
}

interface INewsFeedItemPageState {}

type NewsFeedItemPageProps = INewsFeedItemPageProps &
    INewsFeedItemPageReduxProps &
    INewsFeedItemPageDispatchProps &
    RouteProps &
    RouterProps;

class NewsFeedItemPage extends React.Component<
    NewsFeedItemPageProps,
    INewsFeedItemPageState
> {
    constructor(props: NewsFeedItemPageProps) {
        super(props);
    }

    componentDidMount() {
        this.props.setHeader("Uutisvirta");
        this.props.setBackButton("/newsfeed");
        this.props.setBottomBarTab(NewsFeedTab);
        window.scrollTo(0, 0);

        if (!this.props.item) {
            this.props.loadNewsFeed();
        }
    }

    componentWillUnmount() {
        this.props.hideBackButton();
        this.props.setHeader("");
        this.props.setBottomBarTab();
    }

    contentClicked = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        let target = event.target;

        if (target) {
            const type = target as HTMLLinkElement;
            if (type.href !== undefined) {
                window.open(type.href, "_system");
            }
        }
    };

    render() {
        const item = this.props.item;

        if (!item) {
            return <div></div>;
        }

        const date = new Date(item.date || "").toLocaleDateString("fi");
        const time = new Date(item.date || "").toLocaleTimeString("fi");
        const modifiedContent =
            item.content && item.content.rendered
                ? item.content.rendered.replace(
                      `<img `,
                      `<img style="width: calc(100%); height: 100%" `
                  )
                : "";

        return (
            <div>
                {this.props.loading && (
                    <CircularProgress
                        style={{
                            width: 100,
                            height: 100,
                            color: "#92c9f0",
                            position: "absolute",
                            left: "calc(50% - 50px)",
                            top: "calc(50% - 50px)",
                        }}
                        thickness={2}
                    />
                )}
                {!this.props.loading && (
                    <div style={{ padding: 16 }}>
                        {/* <i>{`${date} ${time}`}</i> */}
                        <h2 className="hypoblue" style={{ marginTop: 0 }}>
                            {(item.title && item.title.rendered) || ""}
                        </h2>
                        <div
                            onClick={this.contentClicked}
                            dangerouslySetInnerHTML={{
                                __html: modifiedContent || "",
                            }}
                        ></div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: NewsFeedItemPageProps
): INewsFeedItemPageReduxProps => {
    const idFromUrl = props.match.params.itemId;
    const newsFeedItem = getNewsFeedItem(state, idFromUrl);
    const loading = newsFeedLoading(state);
    return {
        item: newsFeedItem,
        loading: loading,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): INewsFeedItemPageDispatchProps => {
    return {
        loadNewsFeed: () => {
            return dispatch(loadNewsFeedItems());
        },
        setHeader: (value: string) => {
            dispatch(SetHeader(value));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        setBottomBarTab: (tab?: number) => {
            dispatch(SetBottomBarTab(tab));
        },
    };
};

export default connect<
    INewsFeedItemPageReduxProps,
    INewsFeedItemPageDispatchProps,
    INewsFeedItemPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(NewsFeedItemPage);



// WEBPACK FOOTER //
// ./src/views/newsfeed/NewsFeedItemPage.tsx